exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videoReviewContainer\n{\n    width: 100%;\n    height: 75vh;\n    text-decoration: none;\n}\n\n#videoReviewContainer--BottomPadding\n{\n    margin-bottom: 3%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/videoEmbeded/videoEmbeded.component.css
// module id = ../../../../../src/app/components/videoEmbeded/videoEmbeded.component.css
// module chunks = main